let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}
/*
 * Universal cart-drawer fix
 * ---------------------------------------------------------------
 * Problem: Native "Add to cart" (buy_buttons) is disabled on the
 * product template and replaced by a third-party app button
 * (e.g. the Decorize3D AI Visualizer widget). That app adds items
 * to the cart via its own request, but never tells Dawn's
 * <cart-drawer> component to open/refresh, so the drawer stays
 * closed until the customer manually clicks the cart icon.
 *
 * Fix: Watch every network request the page makes (fetch AND
 * XMLHttpRequest, to cover jQuery/ajax-based app buttons too). If a
 * POST to /cart/add(.js) succeeds, re-render the cart-drawer and
 * cart-icon-bubble sections and open the drawer, regardless of
 * which button/app triggered the add.
 * ---------------------------------------------------------------
 */
(function () {
  if (window.__cartDrawerUniversalFixLoaded) return;
  window.__cartDrawerUniversalFixLoaded = true;

  function isCartAddUrl(url) {
    try {
      var path = (typeof url === 'string' ? url : (url && url.url) || '') + '';
      return /\/cart\/add(\.js)?(\?|$)/.test(path);
    } catch (e) {
      return false;
    }
  }

  function refreshCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return;

    var sectionIds = ['cart-drawer', 'cart-icon-bubble'];
    fetch(window.location.pathname + '?sections=' + sectionIds.join(','))
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        cartDrawer.renderContents({ id: null, sections: sections });
      })
      .catch(function (e) {
        console.error('Kunne ikke opdatere kurv-drawer automatisk:', e);
      });
  }

  // --- fetch()-baserede kald ---
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = (init && init.method) || (typeof input === 'object' && input.method) || 'GET';
    var isAdd = isCartAddUrl(url) && /post/i.test(method);
    var promise = originalFetch.apply(this, arguments);

    if (isAdd) {
      promise
        .then(function (response) {
          if (!response.ok) return;
          response
            .clone()
            .json()
            .then(function (data) {
              if (data && !data.status && !data.errors) {
                refreshCartDrawer();
              }
            })
            .catch(function () {});
        })
        .catch(function () {});
    }

    return promise;
  };

  // --- XMLHttpRequest-baserede kald (fx jQuery.ajax) ---
  var originalOpen = window.XMLHttpRequest.prototype.open;
  var originalSend = window.XMLHttpRequest.prototype.send;

  window.XMLHttpRequest.prototype.open = function (method, url) {
    this.__isCartAdd = /post/i.test(method) && isCartAddUrl(url);
    return originalOpen.apply(this, arguments);
  };

  window.XMLHttpRequest.prototype.send = function () {
    if (this.__isCartAdd) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          try {
            var data = JSON.parse(this.responseText);
            if (data && !data.status && !data.errors) {
              refreshCartDrawer();
            }
          } catch (e) {}
        }
      });
    }
    return originalSend.apply(this, arguments);
  };
})();
